module.exports = __webpack_public_path__ + "img/theme15.4e450293.png";